<mat-tab-group  mat-stretch-tabs="false" mat-align-tabs="start"
                animationDuration="0ms" [color]="'warn'"
                [(selectedIndex)]="selectedTabIndex">
  <mat-tab label="Versements">
    <div *ngIf="selectedTabIndex === TabIndex.versements">
      <app-versements></app-versements>
    </div>
  </mat-tab>
  <mat-tab label="Éliminations">
    <div *ngIf="selectedTabIndex === TabIndex.eliminations">
      <app-liste-bel></app-liste-bel>
    </div>
  </mat-tab>
  <mat-tab label="Demandes de consultation">
    <div *ngIf="selectedTabIndex === TabIndex.consultations">
      <app-list-loanings></app-list-loanings>
    </div>
  </mat-tab>
</mat-tab-group>
